import {StyledMoreActionsCell} from '@components/ui/more-actions-cell/style.ts'
import {TableBodyCellProps} from '@components/ui/table-atoms/TableAtoms.tsx'

export const MoreActionsCell = (props: TableBodyCellProps) => <StyledMoreActionsCell {...props} />
